import { useEffect, useState } from "react";

/**
 * Gibt `wert` erst zurück, wenn er `ms` lang still stand.
 *
 * Gebraucht von `useOrtTreffer` (Photon, SPEC §3 — alle drei Ortsfelder gehen
 * darueber), von der Trefferliste der Kopfleiste (`Suchliste`) und von
 * `Aktuelles`. Ohne Entprellung ginge je Tastendruck eine Anfrage hinaus —
 * bei „Frankfurt" sind das zehn, von denen neun schon veraltet sind, wenn sie
 * ankommen.
 */
export function useEntprellt<T>(wert: T, ms = 350): T {
  const [spaet, setSpaet] = useState(wert);
  useEffect(() => {
    const uhr = setTimeout(() => setSpaet(wert), ms);
    return () => clearTimeout(uhr);
  }, [wert, ms]);
  return spaet;
}
